import * as React from 'react';
import * as styles from './PublishTermsWrapper.css';

interface IPublishTermsWrapperProps {
  children: React.ReactNode;
}

export const PublishTermsWrapper = ({ children }: IPublishTermsWrapperProps) => {
  return (
    <>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>Условия размещения</div>
        <div>{children}</div>
      </div>

      {/* Это хак. Проблема в том, что для старого ФВУ бордер снизу отключен в сегменте ad-placing-terms.
          Но для нового ФВУ он должен быть включен. */}
      <div className={styles['divider']} />
    </>
  );
};
